export function formatPhoneDisplay(phone: string): string {
  if (!/^\+\d+$/.test(phone)) {
    return phone;
  }

  if (phone.startsWith("+54")) {
    let rest = phone.slice(3);
    if (rest.startsWith("9") && rest.length - 1 >= 10) {
      rest = rest.slice(1);
    }
    return groupFromRight(rest).join(" ");
  }

  const groups = groupFromRight(phone.slice(1));
  if (groups.length === 0) {
    return phone;
  }
  return [`+${groups[0]}`, ...groups.slice(1)].join(" ");
}

function groupFromRight(digits: string): string[] {
  if (digits === "") {
    return [];
  }
  const groups: string[] = [];
  for (let end = digits.length; end > 0; end -= 3) {
    groups.unshift(digits.slice(Math.max(0, end - 3), end));
  }
  if (groups.length > 1 && (groups[0] as string).length === 1) {
    groups.splice(0, 2, `${groups[0]}${groups[1]}`);
  }
  return groups;
}

export function nationalDigits(phone: string): string {
  const digits = phone.replace(/\D/g, "");
  if (!digits.startsWith("54")) {
    return digits;
  }
  const rest = digits.slice(2);
  if (rest.startsWith("9") && rest.length === 11) {
    return rest.slice(1);
  }
  return rest;
}

const AR_NATIONAL_LENGTH = 10;
const MIN_INTERNATIONAL_LENGTH = 8;

export function normalizePhone(raw: string): string | null {
  const trimmed = raw.trim();
  const digits = trimmed.replace(/\D/g, "");
  if (digits === "") {
    return null;
  }

  if (trimmed.startsWith("+")) {
    return digits.length >= MIN_INTERNATIONAL_LENGTH ? `+${digits}` : null;
  }

  if (digits.startsWith("00")) {
    const rest = digits.slice(2);
    return rest.length >= MIN_INTERNATIONAL_LENGTH ? `+${rest}` : null;
  }

  if (digits.startsWith("54") && digits.length >= AR_NATIONAL_LENGTH + 2) {
    return `+${digits}`;
  }

  const local = digits.replace(/^0+/, "");

  if (local.length === AR_NATIONAL_LENGTH + 2) {
    const withoutFifteen = dropMobilePrefix(local);
    return withoutFifteen === null ? null : `+549${withoutFifteen}`;
  }

  if (local.length === AR_NATIONAL_LENGTH + 1 && local.startsWith("9")) {
    return `+54${local}`;
  }

  if (local.length === AR_NATIONAL_LENGTH) {
    return `+54${local}`;
  }

  return null;
}

function dropMobilePrefix(local: string): string | null {
  for (const position of [2, 3, 4]) {
    if (local.slice(position, position + 2) === "15") {
      return `${local.slice(0, position)}${local.slice(position + 2)}`;
    }
  }
  return null;
}
